import { ref } from 'vue'

// 积分中心入口暂时隐藏，开放时恢复此开关。
const pointsEntryEnabled = false
const pointsStatusEnum = { enabled: 1, paused: 2, closed: 3 }

// 共享积分入口状态，按登录账号隔离，并复用同次页面加载中的积分中心查询。
export function usePointsEntry({ getToken, fetchCenter }) {
  const visible = ref(false)
  let version = 0
  let pending = null

  function clear() {
    version += 1
    pending = null
    visible.value = false
  }

  function load() {
    const token = getToken()
    if (!token) {
      clear()
      return Promise.resolve(null)
    }
    if (pending?.token === token) return pending.promise
    const requestVersion = ++version
    const request = { token, promise: null }
    const isCurrent = () => requestVersion === version && token === getToken()
    visible.value = false
    pending = request
    request.promise = (async () => {
      try {
        const center = await fetchCenter()
        if (!isCurrent()) return null
        visible.value = pointsEntryEnabled && (center?.status === pointsStatusEnum.enabled || center?.status === pointsStatusEnum.paused)
        return center
      } catch (error) {
        if (!isCurrent()) return null
        visible.value = false
        throw error
      } finally {
        if (pending === request) {
          pending = null
          if (token !== getToken()) visible.value = false
        }
      }
    })()
    return request.promise
  }

  return { visible, load, clear }
}
